import { ProfileType } from '../../../common/enums/ProfileType';
import { TraceType } from '../../../common/enums/TraceType';
import { BaseGQLService } from '../../../common/services/BaseGQLService';
import { FuzzerRuleMapper } from '../mappers/FuzzerRuleMapper';
import { TracerRuleMapper } from '../mappers/TracerRuleMapper';
import { FuzzerRule } from '../models/FuzzerRule';
import { TracerRule } from '../models/TracerRule';

export const GET_RULES_QUERY = `
query($profileType: ProfileType!) {
  rules: analyzerRules(profileType: $profileType) {
    number
    title
    category
    ruleset
    shortExplanation
    compatibleTraceTypes {
      traceType
    }
  }
}`;

export const GET_AVAILABLE_TRACE_TYPES_QUERY = `
query {
  viewer {
    organization {
      allowedTraceTypes
    }
  }
}
`;

export class RulesService extends BaseGQLService {
  private readonly tracerRuleMapper = new TracerRuleMapper();
  private readonly fuzzerRuleMapper = new FuzzerRuleMapper();

  async getTracerRules(): Promise<TracerRule[]> {
    return this.query(
      GET_RULES_QUERY,
      {
        profileType: ProfileType.TRACER,
      },
      (data) => data.rules.map((rule: any) => this.tracerRuleMapper.mapGQLModel(rule))
    );
  }

  async getFuzzerRules(): Promise<FuzzerRule[]> {
    return this.query(
      GET_RULES_QUERY,
      {
        profileType: ProfileType.FUZZER,
      },
      (data) => data.rules.map((rule: any) => this.fuzzerRuleMapper.mapGQLModel(rule))
    );
  }

  async getAvailableTraceTypes(): Promise<TraceType[]> {
    return this.query(GET_AVAILABLE_TRACE_TYPES_QUERY, {}, (data) => data.viewer.organization.allowedTraceTypes);
  }
}
